<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">ประเภทผู้ติดต่อ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'cocContactType'"
                    :name="'cocContactType'"
                    :select2-options="cocContactTypeOptions"
                    v-model="cocContactType"
                    ref="cocContactTypeSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-12">
                <div class="form-group">
                  <label
                    class="label-required"
                    v-show="cocContactType != 'other'"
                    >บริษัท:</label
                  >
                  <label v-show="cocContactType == 'other'">บริษัท:</label>
                  <div v-show="cocContactType == 'agent'">
                    <select2
                      :css-style="'width: 100%;'"
                      :class="'form-control'"
                      :id="'cocAgentId'"
                      :name="'cocAgentId'"
                      :select2-options="cocAgentOptions"
                      v-model="cocAgentId"
                      ref="cocAgentIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="cocContactType == 'vendor'">
                    <select2
                      :css-style="'width: 100%;'"
                      :class="'form-control'"
                      :id="'cocVendorId'"
                      :name="'cocVendorId'"
                      :select2-options="cocVendorOptions"
                      v-model="cocVendorId"
                      ref="cocVendorIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="cocContactType == 'plant'">
                    <select2
                      :css-style="'width: 100%;'"
                      :class="'form-control'"
                      :id="'cocPlantId'"
                      :name="'cocPlantId'"
                      :select2-options="cocPlantOptions"
                      v-model="cocPlantId"
                      ref="cocPlantIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="cocContactType == 'other'">
                    <input
                      id="cocOtherId"
                      name="cocOtherId"
                      v-model="cocOtherId"
                      type="text"
                      maxlength="450"
                      class="form-control"
                      placeholder="ชื่อบริษัท"
                    />
                  </div>
                  <div v-show="!cocContactType">
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'cocCompanyId'"
                      :name="'cocCompanyId'"
                      :select2-options="cocCompanyIdOptions"
                      v-model="cocCompanyId"
                      ref="cocCompanyIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">ชื่อ:</label>
                  <input
                    id="cocContactName"
                    name="cocContactName"
                    v-model="cocContactName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อผู้ติดต่อ"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">นามสกุล:</label>
                  <input
                    id="cocContactLastName"
                    name="cocContactLastName"
                    v-model="cocContactLastName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="นามสกุล"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">ตำแหน่ง:</label>
                  <input
                    id="cocContactPositions"
                    name="cocContactPositions"
                    v-model="cocContactPositions"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ตำแหน่ง"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ชื่อเล่น:</label>
                  <input
                    id="cocContactNickName"
                    name="cocContactNickName"
                    v-model="cocContactNickName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อเล่น"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">เบอร์ติดต่อ:</label>
                  <input
                    id="cocContactTel"
                    name="cocContactTel"
                    v-model="cocContactTel"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="เบอร์ติดต่อ"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">E-mail:</label>
                  <input
                    id="cocContactEmail"
                    name="cocContactEmail"
                    v-model="cocContactEmail"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="E-mail"
                  />
                </div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="cocInActiveStatus"
                        id="cocInActiveStatus"
                        v-model="cocInActiveStatus"
                      />
                      <span></span>
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      cocContactName: null,
      cocContactLastName: null,
      cocContactPositions: null,
      cocContactNickName: null,
      cocContactTel: null,
      cocContactEmail: null,
      cocCompanyId: null,
      cocAgentId: null,
      cocVendorId: null,
      cocPlantId: null,
      cocOtherId: null,
      cocContactType: null,
      cocInActiveStatus: true,
      cocContactTypeOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          { id: "agent", text: "Agent", data: null },
          { id: "vendor", text: "Supplier", data: null },
          { id: "plant", text: "คลังสินค้า", data: null },
          { id: "other", text: "อื่นๆ", data: null },
        ],
      },
      cocCompanyIdOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "", text: "", data: null }],
      },
      cocAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cocVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cocPlantOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Plant/Select2Plant",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        //console.log("if : ");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      var tmp = "";
      if (this.cocContactType == "agent") {
        tmp = this.cocAgentId;
      } else if (this.cocContactType == "vendor") {
        tmp = this.cocVendorId;
      } else if (this.cocContactType == "plant") {
        tmp = this.cocPlantId;
      } else if (this.cocContactType == "other") {
        tmp = this.cocOtherId;
      }

      axios
        .post("/Api/TransitContactor", {
          ContactName: this.cocContactName,
          ContactLastName: this.cocContactLastName,
          ContactPositions: this.cocContactPositions,
          ContactNickName: this.cocContactNickName,
          ContactTel: this.cocContactTel,
          ContactEmail: this.cocContactEmail,
          CompanyType: this.cocContactType,
          CompanyID: tmp,
          InActiveStatus: !this.cocInActiveStatus,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    // validateEmail() {
    //   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   var check = re.test(this.cocContactEmail);
    //   if (check) {
    //     // email valid
    //     console.log("email valid");
    //   } else {
    //     //email invalid
    //     console.log("email invalid");
    //   }
    // },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $(this.$refs.form).validate({
      rules: {
        cocContactType: "required",
        cocCompanyId: "required",
        cocAgentId: "required",
        cocVendorId: "required",
        cocPlantId: "required",
        cocContactName: "required",
        cocContactLastName: "required",
        cocContactPositions: "required",
        cocContactTel: "required",
        cocContactEmail: {
          required: true,
          regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          //email: true,
        },
      },
      messages: {
        cocContactType: "กรุณาเลือกประเภทผู้ติดต่อ",
        cocCompanyId: "กรุณาเลือกบริษัท",
        cocAgentId: "กรุณาเลือกบริษัท",
        cocVendorId: "กรุณาเลือกบริษัท",
        cocPlantId: "กรุณาเลือกบริษัท",
        cocContactName: "กรุณากรอกชื่อ",
        cocContactLastName: "กรุณากรอกนามสกุล",
        cocContactPositions: "กรุณากรอกตำแหน่ง",
        cocContactTel: "กรุณากรอกเบอร์ติดต่อ",
        cocContactEmail: {
          required: "กรุณากรอกอีเมล",
          regex: "กรุณากรอกอีเมลให้ถูกต้อง",
          //email: "กรุณากรอกอีเมลให้ถูกต้อง",
        },
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Contact/ContactCreate.vue